import type { CardProps } from '@chakra-ui/react'
import { Card, forwardRef } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { DashboardCardHeader } from './DashboardCardHeader'

export interface DashboardCardProps extends Omit<CardProps, 'title'> {
  title: ReactNode
  badge?: number | string
}

export const DashboardCard = forwardRef(
  ({ children, title, badge, ...rest }: DashboardCardProps, ref) => {
    return (
      <Card ref={ref} {...rest}>
        <DashboardCardHeader title={title} badge={badge} />

        {children}
      </Card>
    )
  },
)
